import React from 'react'

import '../css/skeleton.css'
import '../css/normalize.css'
import '../css/components.css'

function Footer() {
    return (
        <div className = "Footer container">
            <p>Made with <span role="img" aria-label="heart"> ❤️</span></p>
        </div>
    )
}

export default Footer
